export enum TransactionTypeEnum {
  STOCK_TRANSFER = 'stock_transfer',
  CANCEL_WAREHOUSING = 'cancel_warehousing',
  BOOK_PRODUCT = 'book',
  WRITE_OFF_PRODUCT = 'write_off',
  GOODS_RECEIPT = 'goods_receipt',
  SHIPPING_PRODUCT = 'shipping_product',
}
